
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    //$(window).on('load', function () {
    $(document).ready(function () {
        var $donModal = $("#don-intro-modal");
        if ($donModal.length) {

            var $img = $donModal.find(".don-intro-modal__img");
            $img
                .on("load", function () {
                    // show modal
                    $donModal.modal("show");
                    // show text in modal
                    setTimeout(function () {
                        $(".don-intro-modal__headline").removeClass("is-hidden");
                    }, 4000);
                    // hide modal
                    setTimeout(function () {
                        $donModal.modal("hide");
                    }, 7000);
                })
                .each(function () {
                    if (this.complete) {
                        $(this).trigger('load');
                    }
                });
        }
    });
})(window, document, jQuery);
